import React from 'react';
import { ToastContainer } from 'react-toastify';

import { Unauthenticated, Authenticated } from './Layout';
import { Loading } from './Partials/Layouts';

import MissingAttendance from 'Pages/CheckIn/MissingAttendance';
import CheckIn from 'Pages/CheckIn/CheckIn';

import Me from 'Services/Api/Me/Me';
import Auth from 'Services/Api/Auth/Auth';
import Attendance from 'Services/Api/HumanResource/Attendance';
import { Modal, Scopes } from 'Services';

window.renderCurrency = (value, currency = '£') => {
    let string = null;

    const v = Number(String(value)?.replace(/\,/g,''));

    if(isNaN(v)) {
        string = `${currency}${value ?? 0}`;
    } else {
        string = `${ currency }${ v?.toLocaleString ( undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            useGrouping: true,
        })}`
    }

    return string;
};

/**
 * @classdesc Main app bootstrapper
 */
class App extends React.Component {
    state = {
        user: null,
        loading: true,
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.initUser();

        // Listen for events
        Auth.on('login', this.getUser);
        Auth.on('logout', this.getUser);
        Auth.on('activate', this.getUser);
        Me.on('update', this.getUser);
        Me.on('update-password', this.getUser);
        Me.on('avatar-update', this.getUser);
        Attendance.on('create', this.getUser);
    };

    initUser = () => {
        if (window.appBase?.user) {
            const user = window.appBase.user;

            this.postLoginActions(user);

            return this.setState({
                loading: false,
                user,
            });
        }

        // Check if the user is logged
        this.getUser();
    };

    /**
     * @method getUser
     * @return {Promise<void>}
     */
    getUser = async () => {
        const userRequest = await Me.getMe();
        let user = null;

        if (userRequest.status === 200) {
            user = userRequest.data.data;

            this.postLoginActions(user);
        }

        this.setState({
            loading: false,
            user,
        });
    };

    postLoginActions = (user) => {
        if (user.scopes !== null && user.scopes.length > 0) {
            Scopes.set(user.scopes);
        }

        if (user?.password_needs_updating && window.location.pathname !== '/settings/security/force') {
            window.location = '/settings/security/force';
        } else if (user && (window.location.pathname !== '/settings/security/force' || !user?.password_needs_updating)) {
            if (Scopes.has('attendances.create')) {
                this.checkForCheckin(user);
            }
        }
    };

    /**
     * @method checkForCheckin
     * @return {Promise<void>}
     */
    checkForCheckin = async (user) => {
        // Today
        if (user?.attendance_today === true) {
            Modal.open('checkIn', {
                component: CheckIn,
                props: {
                    user,
                    attendance: user?.attendance_today,
                },
                preventDismissOnNewPage: true,
            });
        }

        // Yesterday
        if (user?.attendance_last_working_day === true) {
            Modal.open('missingAttendance', {
                component: MissingAttendance,
                props: {
                    user,
                },
                preventDismissOnNewPage: true,
            });
        }
    };

    /**
     * @method render
     * @return {*}
     */
    render = () => {
        const { user, loading } = this.state;

        if (loading) {
            return (
                <div className="bg-gray-50 min-h-screen"><Loading/></div>
            );
        }

        return (
            <div className="bg-gray-50 min-h-screen">
                {user !== null ? (<Authenticated user={user}/>) : (<Unauthenticated/>)}

                <ToastContainer
                    hideProgressBar={true}
                    closeButton={false}
                    position="bottom-right"
                    autoClose={2000}
                />
            </div>
        );
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        Auth.removeListener('login', this.getUser);
        Auth.removeListener('logout', this.getUser);
        Auth.removeListener('activate', this.getUser);
        Me.removeListener('update', this.getUser);
        Me.removeListener('update-password', this.getUser);
        Me.removeListener('avatar-update', this.getUser);
        Attendance.removeListener('create', this.getUser);
    };
}

export default App;
